<footer class="footer">
    <div class="row">
        <div class="col-12 col-sm-6 col-lg-3">
            <div class="d-flex flex-column gap-3">
                <h5>
                    {{'COMPONENT.FOOTER.CONCIERGE_CARE_SENIOR_NAVIGATOR' | translate}}
                </h5>
<!--                <a routerLink="#" class="footer-link">-->
<!--                    {{'COMPONENT.FOOTER.LANDING' | translate}}-->
<!--                </a>-->
                <a routerLink="/" class="footer-link">
                    {{'COMPONENT.FOOTER.DASHBOARD' | translate}}
                </a>
                <a routerLink="/auth/login" class="footer-link" *ngIf="!(isLoggedIn$ | async)">
                    {{'COMPONENT.FOOTER.LOG_IN' | translate}}
                </a>
                <a routerLink="/settings/profile" class="footer-link" *ngIf="isLoggedIn$ | async">
                    {{'COMPONENT.FOOTER.ACCOUNT' | translate}}
                </a>
            </div>
        </div>
<!--        <div class="col-12 col-sm-6 col-lg-3">-->
<!--            <h5>-->
<!--                {{'COMPONENT.FOOTER.OUR_PRODUCTS' | translate}}-->
<!--            </h5>-->
<!--            <div class="row pt-2">-->
<!--                <div class="col-12 col-xl-6">-->
<!--                    <div class="d-flex flex-column gap-3">-->

<!--                        <a routerLink="#" class="footer-link">-->
<!--                            {{'COMPONENT.FOOTER.GUIDED_CARE_PLAN' | translate}}-->
<!--                        </a>-->
<!--                        <a routerLink="#" class="footer-link">-->
<!--                            {{'COMPONENT.FOOTER.COST_ESTIMATOR' | translate}}-->
<!--                        </a>-->
<!--                        <a routerLink="#" class="footer-link">-->
<!--                            {{'COMPONENT.FOOTER.GET_CONNECTED' | translate}}-->
<!--                        </a>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="col-12 col-xl-6">-->
<!--                    <div class="d-flex flex-column gap-3">-->
<!--                        <a routerLink="#" class="footer-link">-->
<!--                            {{'COMPONENT.FOOTER.AI_AGENT' | translate}}-->
<!--                        </a>-->
<!--                        <a routerLink="#" class="footer-link">-->
<!--                            {{'COMPONENT.FOOTER.MEDIA_CENTER' | translate}}-->
<!--                        </a>-->
<!--                        <a routerLink="#" class="footer-link">-->
<!--                            {{'COMPONENT.FOOTER.AI_HEALTH_CHECK' | translate}}-->
<!--                        </a>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="col-12 col-sm-6 col-lg-3">-->
<!--            <div class="d-flex flex-column gap-3">-->
<!--                <h5>-->
<!--                    {{'COMPONENT.FOOTER.CONCIERGE_CARE' | translate}}-->
<!--                </h5>-->
<!--                <a routerLink="/home" class="footer-link">-->
<!--                    {{'COMPONENT.FOOTER.HOME' | translate}}-->
<!--                </a>-->
<!--                <a routerLink="#" class="footer-link">-->
<!--                    {{'COMPONENT.FOOTER.CONTACT' | translate}}-->
<!--                </a>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="col-12 col-sm-6 col-lg-3">-->
<!--            <div class="d-flex flex-column gap-3">-->
<!--                <h5>-->
<!--                    {{'COMPONENT.FOOTER.FOR_PARTNERS' | translate}}-->
<!--                </h5>-->
<!--                <ng-container  *ngIf="!(isLoggedIn$ | async)">-->
<!--                    <a routerLink="/auth/registration-start" class="footer-link">-->
<!--                        {{'COMPONENT.FOOTER.SIGN_UP' | translate}}-->
<!--                    </a>-->
<!--                    <a routerLink="/auth/login" class="footer-link">-->
<!--                        {{'COMPONENT.FOOTER.LOG_IN' | translate}}-->
<!--                    </a>-->
<!--                </ng-container>-->

<!--            </div>-->
<!--        </div>-->
    </div>
    <div class="d-flex justify-content-between flex-wrap gap-3 mt-5">
        <div class="d-flex flex-wrap gap-3">
            <p class="my-0">
                {{'COMPONENT.FOOTER.COPY_RIGHTS' | translate}}
            </p>
            <a routerLink="/help/terms-and-conditions" class="footer-link">
                {{'COMPONENT.FOOTER.TERMS_AND_CONDITIONS' | translate}}
            </a>
            <a routerLink="/help/privacy-policy" class="footer-link">
                {{'COMPONENT.FOOTER.PRIVACY_POLICY' | translate}}
            </a>
            <a routerLink="/help/faq" class="footer-link">
                {{'COMPONENT.FOOTER.FAQ' | translate}}
            </a>
        </div>
        <div class="d-flex flex-wrap gap-3">
            <a href="https://www.facebook.com/ConciergeCareAdvisors" target="_blank" class="footer-link">
                {{'COMPONENT.FOOTER.FACEBOOK' | translate}}
            </a>
            <a href="https://conciergecareadvisors.com" target="_blank" class="footer-link">
                {{'COMPONENT.FOOTER.WEBSITE' | translate}}
            </a>
            <a href="https://www.linkedin.com/company/concierge-care-advisors" target="_blank" class="footer-link">
                {{'COMPONENT.FOOTER.LINKEDIN' | translate}}
            </a>
            <a href="https://www.youtube.com/@ConciergeCareTV" target="_blank" class="footer-link">
                {{'COMPONENT.FOOTER.YOUTUBE' | translate}}
            </a>
        </div>
    </div>
</footer>